/* ----- code generated do not modify ----- */
var components_combo_box_locale29 = {
  "buttonLabel": "Prika\u017Ei predloge",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Dostupno jo\u0161: ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcija");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcije/a");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      "true": function _true() {
        return "Unesena grupa ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opcijom");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " optione/a");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      "true": ", izabranih",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Predlozi",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", izabrano");
  }
};

export { components_combo_box_locale29 as default };
//# sourceMappingURL=sr-SP.esm.js.map
